import $http from "@/plugins/axios"

export default {
    state: {
        listDiseaseCategories: [],
    },
    getters: {
        listDiseaseCategories: state => state.listDiseaseCategories
    },
    actions: {
        async getListDiseaseCategories({ commit }, path) {
            const response = await $http.get(path)
            commit("SET_ITEMS", response.data)
        },
    },
    mutations: {
        SET_ITEMS(state, data) {
            state.listDiseaseCategories = data
        }
    }
}